export const getNestedMetric = (summary, key) => {
	if (!summary || !key) return null;
	if (!key.includes(".")) return summary[key] ?? null;
	return key.split(".").reduce((obj, k) => obj?.[k], summary) ?? null;
};

export const formatMetricValue = (value, format = "number", currency = "USD") => {
	if (value === null || value === undefined) return "—";
	switch (format) {
		case "percent":
			return `${Number(value).toFixed(2)}%`;
		case "currency":
			return new Intl.NumberFormat("en-US", {
				style: "currency",
				currency,
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
			}).format(value);
		case "number":
		default:
			return new Intl.NumberFormat("en-US").format(value);
	}
};

export const formatPercentPointDifference = (current, previous) => {
	if (current === null || current === undefined || previous === null || previous === undefined) {
		return "—";
	}

	const diff = Number(current) - Number(previous);
	if (diff === 0) return "0%";

	const sign = diff > 0 ? "+" : "";
	return `${sign}${diff.toFixed(2)}%`;
};

export const formatChangeDifference = (current, previous, format = "number", currency = "USD") => {
	if (current === null || current === undefined || previous === null || previous === undefined) {
		return "—";
	}

	const diff = Number(current) - Number(previous);
	if (diff === 0) return "0";

	if (format === "currency") {
		const formatted = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(Math.abs(diff));
		return diff > 0 ? `+${formatted}` : `-${formatted}`;
	}

	const formatted = new Intl.NumberFormat("en-US").format(Math.abs(diff));
	return diff > 0 ? `+${formatted}` : `-${formatted}`;
};

export const getDeltaClass = (trend, positiveIsGood = true) => {
	if (trend === "flat" || !trend) return "flat";
	if (positiveIsGood) {
		return trend === "up" ? "up-good" : "down-bad";
	}
	return trend === "up" ? "up-bad" : "down-good";
};

export const getTrendArrow = (trend) => {
	if (trend === "up") return "▲";
	if (trend === "down") return "▼";
	return "—";
};
